export const checkAIExceed = (maxCountAI: number, count: number | null) => {
  return isFinite(maxCountAI) && count !== null && count <= 0;
};
